<template>
  <div>
    <main class="main-content">
      <div class="page-content">
        <div class="container-xl">
          <div class="lds-ring" v-if="!isLoad">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <section class="section-commissions" v-if="isLoad">
            <form>
              <div class="page-title page-title_align-center">
                <div class="page-title_ic">
                  <div class="breakdown-cost__table__commision__icon"><span>$</span></div>
                  <h2>Advised Commissions (%)</h2>
                </div>
                <div class="page-title__side">
                  <div :class="['select-wrapper select-wrapper_year', { 'is-active' : yearSelect }]"
                       @click="yearSelect = !yearSelect">
                    <div class="select-trigger"><span
                        class="select-trigger__name">{{ years.find(item => item.active).name }}</span><span
                        class="select-trigger__icon">
                            <svg width="1em" height="1em" class="icon icon-chevron ">
                                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                            </svg></span></div>
                    <div class="select-body">
                      <div class="select-inner js-scrollbar">
                        <div
                            v-for="item in years"
                            :key="item.name"
                            :class="['select-option', {'is-selected' : item.active}]"
                            @click="years = years.map(year => ({...year, active: item.name === year.name}))"><span
                            class="select-option__name">{{ item.name }}</span></div>
                      </div>
                    </div>
                  </div>
                  <button type="button" class="btn btn--green btn--sm-squared" @click="copy = true">
                    <svg width="1em" height="1em" class="icon icon-copy ">
                      <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-copy"></use>
                    </svg>
                  </button>
                </div>
              </div>

              <div class="commission-table">
                <div data-simplebar="data-simplebar" class="section-table-wrap">
                  <table class="default-table year-table">
                    <thead>
                    <tr>
                      <th class="default-table__th default-table__th-title"><span></span></th>
                      <th class="default-table__th"><span>Jan</span></th>
                      <th class="default-table__th"><span>Feb</span></th>
                      <th class="default-table__th"><span>Mar</span></th>
                      <th class="default-table__th"><span>Apr</span></th>
                      <th class="default-table__th"><span>May</span></th>
                      <th class="default-table__th"><span>Jun</span></th>
                      <th class="default-table__th"><span>Jul</span></th>
                      <th class="default-table__th"><span>Aug</span></th>
                      <th class="default-table__th"><span>Sep</span></th>
                      <th class="default-table__th"><span>Oct</span></th>
                      <th class="default-table__th"><span>Nov</span></th>
                      <th class="default-table__th"><span>Dec</span></th>
                    </tr>
                    </thead>
                    <tbody v-if="advices.find(item => item.active)">
                    <tr>
                      <td class="default-table__th-title">
                        <i class="commission-ic">
                          <svg width="1em" height="1em" class="icon icon-safari ">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-safari"></use>
                          </svg>
                        </i>
                        <span>Safari Commission</span>
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.SAFARI['1']"
                                 @input="advices.find(item => item.active).commissions.SAFARI['1'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.SAFARI['2']"
                                 @input="advices.find(item => item.active).commissions.SAFARI['2'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.SAFARI['3']"
                                 @input="advices.find(item => item.active).commissions.SAFARI['3'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.SAFARI['4']"
                                 @input="advices.find(item => item.active).commissions.SAFARI['4'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.SAFARI['5']"
                                 @input="advices.find(item => item.active).commissions.SAFARI['5'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.SAFARI['6']"
                                 @input="advices.find(item => item.active).commissions.SAFARI['6'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.SAFARI['7']"
                                 @input="advices.find(item => item.active).commissions.SAFARI['7'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.SAFARI['8']"
                                 @input="advices.find(item => item.active).commissions.SAFARI['8'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.SAFARI['9']"
                                 @input="advices.find(item => item.active).commissions.SAFARI['9'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.SAFARI['10']"
                                 @input="advices.find(item => item.active).commissions.SAFARI['10'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.SAFARI['11']"
                                 @input="advices.find(item => item.active).commissions.SAFARI['11'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.SAFARI['12']"
                                 @input="advices.find(item => item.active).commissions.SAFARI['12'] = checkValue($event);isEdit = true">
                      </td>
                    </tr>
                    <tr>
                      <td class="default-table__th-title">
                        <i class="commission-ic">
                          <svg width="1em" height="1em" class="icon icon-zanzibar ">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-zanzibar"></use>
                          </svg>
                        </i>
                        <span>Islands Commission</span>
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.ISLAND['1']"
                                 @input="advices.find(item => item.active).commissions.ISLAND['1'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.ISLAND['2']"
                                 @input="advices.find(item => item.active).commissions.ISLAND['2'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.ISLAND['3']"
                                 @input="advices.find(item => item.active).commissions.ISLAND['3'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.ISLAND['4']"
                                 @input="advices.find(item => item.active).commissions.ISLAND['4'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.ISLAND['5']"
                                 @input="advices.find(item => item.active).commissions.ISLAND['5'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.ISLAND['6']"
                                 @input="advices.find(item => item.active).commissions.ISLAND['6'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.ISLAND['7']"
                                 @input="advices.find(item => item.active).commissions.ISLAND['7'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.ISLAND['8']"
                                 @input="advices.find(item => item.active).commissions.ISLAND['8'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.ISLAND['9']"
                                 @input="advices.find(item => item.active).commissions.ISLAND['9'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.ISLAND['10']"
                                 @input="advices.find(item => item.active).commissions.ISLAND['10'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.ISLAND['11']"
                                 @input="advices.find(item => item.active).commissions.ISLAND['11'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.ISLAND['12']"
                                 @input="advices.find(item => item.active).commissions.ISLAND['12'] = checkValue($event);isEdit = true">
                      </td>
                    </tr>
                    <tr v-if="advices.find(item => item.active).commissions.TRANSFER">
                      <td class="default-table__th-title">
                        <i class="commission-ic">
                          <svg width="1em" height="1em" class="icon icon-zanzibar ">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-zanzibar"></use>
                          </svg>
                        </i>
                        <span>Transfers Commission</span>
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.TRANSFER['1']"
                                 @input="advices.find(item => item.active).commissions.TRANSFER['1'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.TRANSFER['2']"
                                 @input="advices.find(item => item.active).commissions.TRANSFER['2'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.TRANSFER['3']"
                                 @input="advices.find(item => item.active).commissions.TRANSFER['3'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.TRANSFER['4']"
                                 @input="advices.find(item => item.active).commissions.TRANSFER['4'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.TRANSFER['5']"
                                 @input="advices.find(item => item.active).commissions.TRANSFER['5'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.TRANSFER['6']"
                                 @input="advices.find(item => item.active).commissions.TRANSFER['6'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.TRANSFER['7']"
                                 @input="advices.find(item => item.active).commissions.TRANSFER['7'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.TRANSFER['8']"
                                 @input="advices.find(item => item.active).commissions.TRANSFER['8'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.TRANSFER['9']"
                                 @input="advices.find(item => item.active).commissions.TRANSFER['9'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.TRANSFER['10']"
                                 @input="advices.find(item => item.active).commissions.TRANSFER['10'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.TRANSFER['11']"
                                 @input="advices.find(item => item.active).commissions.TRANSFER['11'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.TRANSFER['12']"
                                 @input="advices.find(item => item.active).commissions.TRANSFER['12'] = checkValue($event);isEdit = true">
                      </td>
                    </tr>
                    <tr v-if="advices.find(item => item.active).commissions.ACTIVITY">
                      <td class="default-table__th-title">
                        <i class="commission-ic">
                          <svg width="1em" height="1em" class="icon icon-parachute ">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-parachute"></use>
                          </svg>
                        </i>
                        <span>Activity Commission</span>
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.ACTIVITY['1']"
                                 @input="advices.find(item => item.active).commissions.ACTIVITY['1'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.ACTIVITY['2']"
                                 @input="advices.find(item => item.active).commissions.ACTIVITY['2'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.ACTIVITY['3']"
                                 @input="advices.find(item => item.active).commissions.ACTIVITY['3'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.ACTIVITY['4']"
                                 @input="advices.find(item => item.active).commissions.ACTIVITY['4'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.ACTIVITY['5']"
                                 @input="advices.find(item => item.active).commissions.ACTIVITY['5'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.ACTIVITY['6']"
                                 @input="advices.find(item => item.active).commissions.ACTIVITY['6'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.ACTIVITY['7']"
                                 @input="advices.find(item => item.active).commissions.ACTIVITY['7'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.ACTIVITY['8']"
                                 @input="advices.find(item => item.active).commissions.ACTIVITY['8'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.ACTIVITY['9']"
                                 @input="advices.find(item => item.active).commissions.ACTIVITY['9'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.ACTIVITY['10']"
                                 @input="advices.find(item => item.active).commissions.ACTIVITY['10'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.ACTIVITY['11']"
                                 @input="advices.find(item => item.active).commissions.ACTIVITY['11'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.ACTIVITY['12']"
                                 @input="advices.find(item => item.active).commissions.ACTIVITY['12'] = checkValue($event);isEdit = true">
                      </td>
                    </tr>
                    <tr>
                      <td class="default-table__th-title">
                        <i class="commission-ic">
                          <svg width="1em" height="1em" class="icon icon-airplane ">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-airplane"></use>
                          </svg>
                        </i>
                        <span>Flights Commission</span>
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.FLIGHT['1']"
                                 @input="advices.find(item => item.active).commissions.FLIGHT['1'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.FLIGHT['2']"
                                 @input="advices.find(item => item.active).commissions.FLIGHT['2'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.FLIGHT['3']"
                                 @input="advices.find(item => item.active).commissions.FLIGHT['3'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.FLIGHT['4']"
                                 @input="advices.find(item => item.active).commissions.FLIGHT['4'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.FLIGHT['5']"
                                 @input="advices.find(item => item.active).commissions.FLIGHT['5'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.FLIGHT['6']"
                                 @input="advices.find(item => item.active).commissions.FLIGHT['6'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.FLIGHT['7']"
                                 @input="advices.find(item => item.active).commissions.FLIGHT['7'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.FLIGHT['8']"
                                 @input="advices.find(item => item.active).commissions.FLIGHT['8'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.FLIGHT['9']"
                                 @input="advices.find(item => item.active).commissions.FLIGHT['9'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.FLIGHT['10']"
                                 @input="advices.find(item => item.active).commissions.FLIGHT['10'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.FLIGHT['11']"
                                 @input="advices.find(item => item.active).commissions.FLIGHT['11'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.FLIGHT['12']"
                                 @input="advices.find(item => item.active).commissions.FLIGHT['12'] = checkValue($event);isEdit = true">
                      </td>
                    </tr>
                    <tr v-if="advices.find(item => item.active).commissions.OTHER">
                      <td class="default-table__th-title">
                        <i class="commission-ic">
                          <svg width="1em" height="1em" class="icon icon-other ">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-other"></use>
                          </svg>
                        </i>
                        <span>Other Commission</span>
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.OTHER['1']"
                                 @input="advices.find(item => item.active).commissions.OTHER['1'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.OTHER['2']"
                                 @input="advices.find(item => item.active).commissions.OTHER['2'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.OTHER['3']"
                                 @input="advices.find(item => item.active).commissions.OTHER['3'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.OTHER['4']"
                                 @input="advices.find(item => item.active).commissions.OTHER['4'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.OTHER['5']"
                                 @input="advices.find(item => item.active).commissions.OTHER['5'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.OTHER['6']"
                                 @input="advices.find(item => item.active).commissions.OTHER['6'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.OTHER['7']"
                                 @input="advices.find(item => item.active).commissions.OTHER['7'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.OTHER['8']"
                                 @input="advices.find(item => item.active).commissions.OTHER['8'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.OTHER['9']"
                                 @input="advices.find(item => item.active).commissions.OTHER['9'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.OTHER['10']"
                                 @input="advices.find(item => item.active).commissions.OTHER['10'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.OTHER['11']"
                                 @input="advices.find(item => item.active).commissions.OTHER['11'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).commissions.OTHER['12']"
                                 @input="advices.find(item => item.active).commissions.OTHER['12'] = checkValue($event);isEdit = true">
                      </td>
                    </tr>
                    <tr v-if="advices.find(item => item.active).commissions.EXTRA_ACCOMMODATION">
                      <td class="default-table__th-title">
                        <i class="commission-ic">
                          <svg width="1em" height="1em" class="icon icon-other ">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-other"></use>
                          </svg>
                        </i>
                        <span>Extra Accommodation Commission</span>
                      </td>
                      <td><input type="text"
                                 v-model="advices.find(item => item.active).commissions.EXTRA_ACCOMMODATION['1']"
                                 @input="advices.find(item => item.active).commissions.EXTRA_ACCOMMODATION['1'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text"
                                 v-model="advices.find(item => item.active).commissions.EXTRA_ACCOMMODATION['2']"
                                 @input="advices.find(item => item.active).commissions.EXTRA_ACCOMMODATION['2'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text"
                                 v-model="advices.find(item => item.active).commissions.EXTRA_ACCOMMODATION['3']"
                                 @input="advices.find(item => item.active).commissions.EXTRA_ACCOMMODATION['3'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text"
                                 v-model="advices.find(item => item.active).commissions.EXTRA_ACCOMMODATION['4']"
                                 @input="advices.find(item => item.active).commissions.EXTRA_ACCOMMODATION['4'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text"
                                 v-model="advices.find(item => item.active).commissions.EXTRA_ACCOMMODATION['5']"
                                 @input="advices.find(item => item.active).commissions.EXTRA_ACCOMMODATION['5'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text"
                                 v-model="advices.find(item => item.active).commissions.EXTRA_ACCOMMODATION['6']"
                                 @input="advices.find(item => item.active).commissions.EXTRA_ACCOMMODATION['6'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text"
                                 v-model="advices.find(item => item.active).commissions.EXTRA_ACCOMMODATION['7']"
                                 @input="advices.find(item => item.active).commissions.EXTRA_ACCOMMODATION['7'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text"
                                 v-model="advices.find(item => item.active).commissions.EXTRA_ACCOMMODATION['8']"
                                 @input="advices.find(item => item.active).commissions.EXTRA_ACCOMMODATION['8'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text"
                                 v-model="advices.find(item => item.active).commissions.EXTRA_ACCOMMODATION['9']"
                                 @input="advices.find(item => item.active).commissions.EXTRA_ACCOMMODATION['9'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text"
                                 v-model="advices.find(item => item.active).commissions.EXTRA_ACCOMMODATION['10']"
                                 @input="advices.find(item => item.active).commissions.EXTRA_ACCOMMODATION['10'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text"
                                 v-model="advices.find(item => item.active).commissions.EXTRA_ACCOMMODATION['11']"
                                 @input="advices.find(item => item.active).commissions.EXTRA_ACCOMMODATION['11'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text"
                                 v-model="advices.find(item => item.active).commissions.EXTRA_ACCOMMODATION['12']"
                                 @input="advices.find(item => item.active).commissions.EXTRA_ACCOMMODATION['12'] = checkValue($event);isEdit = true">
                      </td>
                    </tr>
                    <tr v-if="advices.find(item => item.active).commissions.AIRPORT_VIP_SERVICES">
                      <td class="default-table__th-title">
                        <i class="commission-ic">
                          <svg width="1em" height="1em" class="icon icon-other ">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-other"></use>
                          </svg>
                        </i>
                        <span>Airport VIP Services Commission</span>
                      </td>
                      <td><input type="text"
                                 v-model="advices.find(item => item.active).commissions.AIRPORT_VIP_SERVICES['1']"
                                 @input="advices.find(item => item.active).commissions.AIRPORT_VIP_SERVICES['1'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text"
                                 v-model="advices.find(item => item.active).commissions.AIRPORT_VIP_SERVICES['2']"
                                 @input="advices.find(item => item.active).commissions.AIRPORT_VIP_SERVICES['2'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text"
                                 v-model="advices.find(item => item.active).commissions.AIRPORT_VIP_SERVICES['3']"
                                 @input="advices.find(item => item.active).commissions.AIRPORT_VIP_SERVICES['3'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text"
                                 v-model="advices.find(item => item.active).commissions.AIRPORT_VIP_SERVICES['4']"
                                 @input="advices.find(item => item.active).commissions.AIRPORT_VIP_SERVICES['4'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text"
                                 v-model="advices.find(item => item.active).commissions.AIRPORT_VIP_SERVICES['5']"
                                 @input="advices.find(item => item.active).commissions.AIRPORT_VIP_SERVICES['5'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text"
                                 v-model="advices.find(item => item.active).commissions.AIRPORT_VIP_SERVICES['6']"
                                 @input="advices.find(item => item.active).commissions.AIRPORT_VIP_SERVICES['6'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text"
                                 v-model="advices.find(item => item.active).commissions.AIRPORT_VIP_SERVICES['7']"
                                 @input="advices.find(item => item.active).commissions.AIRPORT_VIP_SERVICES['7'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text"
                                 v-model="advices.find(item => item.active).commissions.AIRPORT_VIP_SERVICES['8']"
                                 @input="advices.find(item => item.active).commissions.AIRPORT_VIP_SERVICES['8'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text"
                                 v-model="advices.find(item => item.active).commissions.AIRPORT_VIP_SERVICES['9']"
                                 @input="advices.find(item => item.active).commissions.AIRPORT_VIP_SERVICES['9'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text"
                                 v-model="advices.find(item => item.active).commissions.AIRPORT_VIP_SERVICES['10']"
                                 @input="advices.find(item => item.active).commissions.AIRPORT_VIP_SERVICES['10'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text"
                                 v-model="advices.find(item => item.active).commissions.AIRPORT_VIP_SERVICES['11']"
                                 @input="advices.find(item => item.active).commissions.AIRPORT_VIP_SERVICES['11'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text"
                                 v-model="advices.find(item => item.active).commissions.AIRPORT_VIP_SERVICES['12']"
                                 @input="advices.find(item => item.active).commissions.AIRPORT_VIP_SERVICES['12'] = checkValue($event);isEdit = true">
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>


              <div class="page-title page-title_advised">
                <div class="page-title_ic">
                  <div class="breakdown-cost__table__commision__icon breakdown-cost__table__commision__icon-percent">
                    <svg  class="icon icon-precent ">
                      <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-percent"></use>
                    </svg>
                  </div>
                  <h2>Advised Disount (%)</h2>
                </div>

              </div>

              <div class="commission-table">
                <div data-simplebar="data-simplebar" class="section-table-wrap">
                  <table class="default-table year-table">
                    <thead>
                    <tr>
                      <th class="default-table__th default-table__th-title"><span></span></th>
                      <th class="default-table__th"><span>Jan</span></th>
                      <th class="default-table__th"><span>Feb</span></th>
                      <th class="default-table__th"><span>Mar</span></th>
                      <th class="default-table__th"><span>Apr</span></th>
                      <th class="default-table__th"><span>May</span></th>
                      <th class="default-table__th"><span>Jun</span></th>
                      <th class="default-table__th"><span>Jul</span></th>
                      <th class="default-table__th"><span>Aug</span></th>
                      <th class="default-table__th"><span>Sep</span></th>
                      <th class="default-table__th"><span>Oct</span></th>
                      <th class="default-table__th"><span>Nov</span></th>
                      <th class="default-table__th"><span>Dec</span></th>
                    </tr>
                    </thead>
                    <tbody v-if="advices.find(item => item.active)">
                    <tr>
                      <td class="default-table__th-title">
                        <i class="commission-ic">
                          <svg width="1em" height="1em" class="icon icon-climbing ">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-climbing"></use>
                          </svg>
                        </i>
                        <span class="default-table__th-text">Climb Discount</span>
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).discounts.CLIMB['1']"
                                 @input="advices.find(item => item.active).discounts.CLIMB['1'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).discounts.CLIMB['2']"
                                 @input="advices.find(item => item.active).discounts.CLIMB['2'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).discounts.CLIMB['3']"
                                 @input="advices.find(item => item.active).discounts.CLIMB['3'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).discounts.CLIMB['4']"
                                 @input="advices.find(item => item.active).discounts.CLIMB['4'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).discounts.CLIMB['5']"
                                 @input="advices.find(item => item.active).discounts.CLIMB['5'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).discounts.CLIMB['6']"
                                 @input="advices.find(item => item.active).discounts.CLIMB['6'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).discounts.CLIMB['7']"
                                 @input="advices.find(item => item.active).discounts.CLIMB['7'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).discounts.CLIMB['8']"
                                 @input="advices.find(item => item.active).discounts.CLIMB['8'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).discounts.CLIMB['9']"
                                 @input="advices.find(item => item.active).discounts.CLIMB['9'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).discounts.CLIMB['10']"
                                 @input="advices.find(item => item.active).discounts.CLIMB['10'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).discounts.CLIMB['11']"
                                 @input="advices.find(item => item.active).discounts.CLIMB['11'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).discounts.CLIMB['12']"
                                 @input="advices.find(item => item.active).discounts.CLIMB['12'] = checkValue($event);isEdit = true">
                      </td>
                    </tr>
                    <tr>
                      <td class="default-table__th-title">
                        <i class="commission-ic">
                          <svg width="1em" height="1em" class="icon icon-zanzibar ">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-zanzibar"></use>
                          </svg>
                        </i>
                        <span class="default-table__th-text">Climb Additionals Discount</span>
                      </td>
                      <td><input type="text"
                                 v-model="advices.find(item => item.active).discounts.CLIMB_ADDITIONAL_OPTIONS['1']"
                                 @input="advices.find(item => item.active).discounts.CLIMB_ADDITIONAL_OPTIONS['1'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text"
                                 v-model="advices.find(item => item.active).discounts.CLIMB_ADDITIONAL_OPTIONS['2']"
                                 @input="advices.find(item => item.active).discounts.CLIMB_ADDITIONAL_OPTIONS['2'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text"
                                 v-model="advices.find(item => item.active).discounts.CLIMB_ADDITIONAL_OPTIONS['3']"
                                 @input="advices.find(item => item.active).discounts.CLIMB_ADDITIONAL_OPTIONS['3'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text"
                                 v-model="advices.find(item => item.active).discounts.CLIMB_ADDITIONAL_OPTIONS['4']"
                                 @input="advices.find(item => item.active).discounts.CLIMB_ADDITIONAL_OPTIONS['4'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text"
                                 v-model="advices.find(item => item.active).discounts.CLIMB_ADDITIONAL_OPTIONS['5']"
                                 @input="advices.find(item => item.active).discounts.CLIMB_ADDITIONAL_OPTIONS['5'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text"
                                 v-model="advices.find(item => item.active).discounts.CLIMB_ADDITIONAL_OPTIONS['6']"
                                 @input="advices.find(item => item.active).discounts.CLIMB_ADDITIONAL_OPTIONS['6'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text"
                                 v-model="advices.find(item => item.active).discounts.CLIMB_ADDITIONAL_OPTIONS['7']"
                                 @input="advices.find(item => item.active).discounts.CLIMB_ADDITIONAL_OPTIONS['7'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text"
                                 v-model="advices.find(item => item.active).discounts.CLIMB_ADDITIONAL_OPTIONS['8']"
                                 @input="advices.find(item => item.active).discounts.CLIMB_ADDITIONAL_OPTIONS['8'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text"
                                 v-model="advices.find(item => item.active).discounts.CLIMB_ADDITIONAL_OPTIONS['9']"
                                 @input="advices.find(item => item.active).discounts.CLIMB_ADDITIONAL_OPTIONS['9'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text"
                                 v-model="advices.find(item => item.active).discounts.CLIMB_ADDITIONAL_OPTIONS['10']"
                                 @input="advices.find(item => item.active).discounts.CLIMB_ADDITIONAL_OPTIONS['10'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text"
                                 v-model="advices.find(item => item.active).discounts.CLIMB_ADDITIONAL_OPTIONS['11']"
                                 @input="advices.find(item => item.active).discounts.CLIMB_ADDITIONAL_OPTIONS['11'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text"
                                 v-model="advices.find(item => item.active).discounts.CLIMB_ADDITIONAL_OPTIONS['12']"
                                 @input="advices.find(item => item.active).discounts.CLIMB_ADDITIONAL_OPTIONS['12'] = checkValue($event);isEdit = true">
                      </td>
                    </tr>
                    <tr>
                      <td class="default-table__th-title">
                        <i class="commission-ic">
                          <svg width="1em" height="1em" class="icon icon-parachute ">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-parachute"></use>
                          </svg>
                        </i>
                        <span class="default-table__th-text">Day Trips Discount</span>
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).discounts.DAY_TRIPS['1']"
                                 @input="advices.find(item => item.active).discounts.DAY_TRIPS['1'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).discounts.DAY_TRIPS['2']"
                                 @input="advices.find(item => item.active).discounts.DAY_TRIPS['2'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).discounts.DAY_TRIPS['3']"
                                 @input="advices.find(item => item.active).discounts.DAY_TRIPS['3'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).discounts.DAY_TRIPS['4']"
                                 @input="advices.find(item => item.active).discounts.DAY_TRIPS['4'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).discounts.DAY_TRIPS['5']"
                                 @input="advices.find(item => item.active).discounts.DAY_TRIPS['5'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).discounts.DAY_TRIPS['6']"
                                 @input="advices.find(item => item.active).discounts.DAY_TRIPS['6'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).discounts.DAY_TRIPS['7']"
                                 @input="advices.find(item => item.active).discounts.DAY_TRIPS['7'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).discounts.DAY_TRIPS['8']"
                                 @input="advices.find(item => item.active).discounts.DAY_TRIPS['8'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).discounts.DAY_TRIPS['9']"
                                 @input="advices.find(item => item.active).discounts.DAY_TRIPS['9'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).discounts.DAY_TRIPS['10']"
                                 @input="advices.find(item => item.active).discounts.DAY_TRIPS['10'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).discounts.DAY_TRIPS['11']"
                                 @input="advices.find(item => item.active).discounts.DAY_TRIPS['11'] = checkValue($event);isEdit = true">
                      </td>
                      <td><input type="text" v-model="advices.find(item => item.active).discounts.DAY_TRIPS['12']"
                                 @input="advices.find(item => item.active).discounts.DAY_TRIPS['12'] = checkValue($event);isEdit = true">
                      </td>
                    </tr>

                    </tbody>
                  </table>
                </div>
              </div>
              <div class="table-save-btn">
                <button type="button" class="btn btn--green" @click="updateAdviceHandler"><span>Save</span></button>
              </div>
            </form>

            <div class="page-title page-title_advised">
              <div class="page-title_ic">
                <h2>Safari Commission Deduction</h2>
              </div>

            </div>
            <div class="safari-duration-discounts">
              <div class="discount-row_labels">
                <span>Safari Duration:</span>
                <span>Commissions Change:</span>
                <span>Additional Note:</span>
              </div>
              <div v-for="(item, index) in discounts" :key="item.id || index" class="discount-row">
                <BasicInput
                  type="number"
                  v-model.number="item.duration"
                  placeholder="Safari Duration"
                />

                <div
                  class="form-control-group form-control-group_currency">
                  <div
                    class="form-control-wrap form-control-wrap_with-label form-control-wrap_with-label_low">
                    <input type="number"
                           class="form-control"
                           v-model.number="item.discountPercentage"
                           @change="isEdit = true">
                    <span class="label-inp">%</span>
                  </div>
                </div>

                <BasicInput
                  type="text"
                  v-model="item.note"
                  placeholder="Additional Note"
                />

                <button class="discount-row_remove" @click="removeDiscountRow(index)">x</button>

              </div>

              <button class="discount-row_add" @click="addDiscountRow">Add</button>

              <div class="table-save-btn">
                <button class="btn btn--green" @click="saveSafariDiscounts"><span>Save</span></button>
              </div>
            </div>
          </section>
        </div>
      </div>
    </main>
    <div class="modal-wrapper" v-if="copy">
      <div class="modal-backdrop"></div>
      <div class="modal-inner">
        <div class="edit-popup edit-popup--copy-md">
          <div class="edit-popup__header">
            <div class="edit-popup__title">
              <div class="edit-popup__title__icon">
                <svg width="1em" height="1em" class="icon icon-copy ">
                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-copy"></use>
                </svg>
              </div>
              <span>Copy comissions</span>
            </div>
            <div class="edit-popup__close" @click="copy = false">
              <svg width="1em" height="1em" class="icon icon-close ">
                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
              </svg>
            </div>
          </div>
          <form action="javascript:void(0)" class="edit-popup__inner">
            <div class="edit-popup__form-2">
              <div class="form-control-group"><span class="form-control-label">Choose year</span>
                <div :class="['select-wrapper select-wrapper_year', { 'is-active' : yearCopySelect }]"
                     @click="yearCopySelect = !yearCopySelect">
                  <div class="select-trigger"><span
                      class="select-trigger__name">{{ yearsCopy.find(item => item.active).name }}</span><span
                      class="select-trigger__icon">
                            <svg width="1em" height="1em" class="icon icon-chevron ">
                                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                            </svg></span></div>
                  <div class="select-body">
                    <div class="select-inner js-scrollbar">
                      <div
                          v-for="item in yearsCopy"
                          :key="item.name"
                          :class="['select-option', {'is-selected' : item.active}]"
                          @click="yearsCopy = yearsCopy.map(year => ({...year, active: item.name === year.name}))"><span
                          class="select-option__name">{{ item.name }}</span></div>
                    </div>
                  </div>
                </div>
              </div>
              <button type="submit" class="btn btn--green edit-popup__submit-2" @click="copyAdviceHandler">
                <svg width="1em" height="1em" class="icon icon-copy ">
                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-copy"></use>
                </svg>
                <span>Copy</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {
  getAdvices,
  updateAdvice,
  copyAdvice, getSafariDurationDiscounts, putSafariDurationDiscounts
} from '@/utilites/api'
import ClipboardJS from 'clipboard'
import BasicInput from '@/components/UI/Inputs/BasicInput.vue'
import Input from '@/components/UI/Inputs/BasicInput.vue'

export default {
  data() {
    return {
      advices: [],
      yearSelect: false,
      copy: false,
      yearCopySelect: false,
      years: [
        {
          name: 2021,
          active: true
        },
        {
          name: 2022,
          active: false
        },
        {
          name: 2023,
          active: false
        },
        {
          name: 2024,
          active: false
        },
        {
          name: 2025,
          active: false
        },
        {
          name: 2026,
          active: false
        },
        {
          name: 2027,
          active: false
        },
        {
          name: 2028,
          active: false
        },
        {
          name: 2029,
          active: false
        },
        {
          name: 2030,
          active: false
        },
      ],
      yearsCopy: [
        {
          name: 2021,
          active: true
        },
        {
          name: 2022,
          active: false
        },
        {
          name: 2023,
          active: false
        },
        {
          name: 2024,
          active: false
        },
        {
          name: 2025,
          active: false
        },
        {
          name: 2026,
          active: false
        },
        {
          name: 2027,
          active: false
        },
        {
          name: 2028,
          active: false
        },
        {
          name: 2029,
          active: false
        },
        {
          name: 2030,
          active: false
        },
      ],
      isLoad: false,
      isEdit: false,
      discounts: []
    }
  },
  props: ['user'],
  components: {Input, BasicInput, ClipboardJS},
  beforeRouteLeave(to, from, next) {
    if (this.isEdit) {
      this.$emit('notLeaveHandler')
    }
    next()
  },
  beforeCreate() {
    document.title = 'Setting & Data | General | Commission advanced'
  },
  mounted() {
    document.title = 'Setting & Data | General | Commission advanced'
    getAdvices(this.user.access_token)
        .then(res => {
          this.isLoad = true
          this.advices = res.map((item) => ({
            ...item,
            active: item.year === new Date().getFullYear(),
            commissions: {
              ACTIVITY: item.commissions.ACTIVITY || {},
              FLIGHT: item.commissions.FLIGHT || {},
              ISLAND: item.commissions.ISLAND || {},
              OTHER: item.commissions.OTHER || {},
              SAFARI: item.commissions.SAFARI || {},
              EXTRA_ACCOMMODATION: item.commissions.EXTRA_ACCOMMODATION || {},
              TRANSFER: item.commissions.TRANSFER || {},
              AIRPORT_VIP_SERVICES: item.commissions.AIRPORT_VIP_SERVICES || {},
            },
            discounts: {
              CLIMB: item.discounts.CLIMB || {},
              CLIMB_ADDITIONAL_OPTIONS: item.discounts.CLIMB_ADDITIONAL_OPTIONS || {},
              DAY_TRIPS: item.discounts.DAY_TRIPS || {}
            }
          }))
        })

    try {
      getSafariDurationDiscounts(this.years.find(year => year.active).name).then(response => {
        if (response.data.discounts) {
          this.discounts = response.data.discounts
        }
      })
    } catch (e) {
      console.error("GET error:", e);
    }
    window.addEventListener('click', event => {
      if (!event.target.closest('.select-wrapper')) {
        this.yearSelect = false,
            this.yearCopySelect = false
      }
      if (!event.target.closest('.edit-popup') && !event.target.closest('.btn')) {
        this.copy = false
      }
    })
  },
  methods: {
    updateAdviceHandler() {
      let active = this.advices.find(item => item.active)
      updateAdvice(this.user.access_token, {
        year: active.year,
        commissions: active.commissions,
        discounts: active.discounts
      })
          .then(res => {
            // console.log(res)
            this.$emit('confirmed')
            this.isEdit = false
          })
    },
    async saveSafariDiscounts() {
      const selectedYear = this.years.find(year => year.active).name || 1970;
      const payload = {
        year: selectedYear,
        discounts: this.discounts.map(item => ({
          id: item.id || null,
          duration: item.duration,
          discountPercentage: item.discountPercentage,
          note: item.note,
        }))
      };

      try {
        await putSafariDurationDiscounts(payload);
        this.$emit('confirmed')
        this.isEdit = false
      } catch (e) {
        console.error("PUT error:", e);
      }
    },
    addDiscountRow() {
      this.discounts.push({
        id: null,
        duration: 0,
        discountPercentage: 0,
        note: "",
      });
    },
    removeDiscountRow(index) {
      this.discounts.splice(index, 1);
    },
    copyAdviceHandler() {
      copyAdvice(this.user.access_token, this.yearsCopy.find(item => item.active).name, this.years.find(item => item.active).name)
          .then(res => {
            this.isEdit = true
            this.advices = this.advices.map(item => {
              if (item.year === res.year) {
                return {
                  ...res,
                  active: true
                }
              }
              return item
            })
            this.copy = false
          })
    },
    checkValue(event) {
      let num = event.target.value.replace(/\D/g, '')
      if (+num > 100) {
        return 100
      }
      if (num === '') {
        return num
      }
      return +num
    }
  },
  watch: {
    years() {
      let active = this.advices.map(item => ({
        ...item,
        active: item.year === this.years.find(item => item.active).name
      })).find(item => item.active)
      if (active) {
        this.advices = this.advices.map(item => ({
          ...item,
          active: item.year === this.years.find(item => item.active).name,
          commissions: {
            ACTIVITY: item.commissions.ACTIVITY || {},
            FLIGHT: item.commissions.FLIGHT || {},
            ISLAND: item.commissions.ISLAND || {},
            OTHER: item.commissions.OTHER || {},
            SAFARI: item.commissions.SAFARI || {},
            EXTRA_ACCOMMODATION: item.commissions.EXTRA_ACCOMMODATION || {},
            TRANSFER: item.commissions.TRANSFER || {},
            AIRPORT_VIP_SERVICES: item.commissions.AIRPORT_VIP_SERVICES || {},
          },
          discounts: {
            CLIMB: item.discounts.CLIMB || {},
            CLIMB_ADDITIONAL_OPTIONS: item.discounts.CLIMB_ADDITIONAL_OPTIONS || {},
            DAY_TRIPS: item.discounts.DAY_TRIPS || {}
          }
        }))
      } else {
        this.advices = this.advices.map(item => ({...item, active: false})).concat({
          year: this.years.find(item => item.active).name,
          active: true,
          commissions: {
            ACTIVITY: {},
            FLIGHT: {},
            ISLAND: {},
            OTHER: {},
            SAFARI: {},
            EXTRA_ACCOMMODATION: {},
            TRANSFER: {},
            AIRPORT_VIP_SERVICES: {},
          },
          discounts: {
            CLIMB: {},
            CLIMB_ADDITIONAL_OPTIONS: {},
            DAY_TRIPS: {}
          }
        })
      }

      try {
        getSafariDurationDiscounts(this.years.find(year => year.active).name).then(response => {
          if (response.data.discounts) {
            this.discounts = response.data.discounts
          }
        })
      } catch (e) {
        console.error("GET error:", e);
      }

    },
  }
}
</script>
<style lang="scss" scoped>
.discount-row {
  display: flex;
  gap: 24px;
  align-items: center;
  padding: 6px 0;
  width: 100%;

  &_add {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 10px 16px;
    background: #77B017;
    color: #fff;
    border-radius: 80px;
    cursor: pointer;
    user-select: none;
    font-size: 14px;
    max-width: 180px;
    width: 100px;
    height: 30px;
    gap: 8px;
    margin-top: 10px;
  }

  &_remove {
    font-size: 16px;
    cursor: pointer;
    height: 26px;
    width: 26px;
    border: 1px solid #EAEAEA;
    border-radius: 100%;
    color: #ADADAD;
  }

  &_labels {
    display: flex;
    gap: 12px;
    font-size: 12px;
    width: 100%;
    align-items: center;

    span:nth-child(1) {
      width: 195px;
    }
    span:nth-child(2) {
      width: 84px;
    }
    span:nth-child(3) {
      width: 120px;
    }
  }
}
</style>